import { useHistory } from 'react-router-dom'

import config from 'config'

import arrowLeft from 'static/img/arrow/arrow-left.svg'
import questionMark from 'static/img/help-icon.svg'
import brandmark from 'static/img/logo/backer-brandmark.svg'
import styles from './AuthHeader.module.scss'

const AuthHeader = ({
  hideHelp
}: {
  hideHelp?: boolean
}) => {
  const history = useHistory()

  return (
    <div className={styles.container}>
      <a href={config.BACKEND_ROOT_URL} className={styles.logoLink}>
        <img src={brandmark} className={styles.backerLogo} alt="homepage" />
      </a>
      <button
        type="button"
        className={styles.backArrowBtn}
        onClick={() => history.goBack()}
      >
        <img src={arrowLeft} alt="back" className="back-arrow-icon" />
      </button>
      {!hideHelp && (
        <a
          href={config.HELP_URL}
          className={styles.questionMark}
          target="_blank"
          rel="noreferrer"
        >
          <img src={questionMark} alt="help" />
        </a>
      )}
    </div>
  )
}

export default AuthHeader